module.exports = __webpack_public_path__ + "img/mask_group_3.a492f080.png";